import React from "react";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
import Grid from "@mui/material/Grid";

import Button from '@mui/material/Button';

const syncBtnStyle = {
    background: "rgb(193, 39, 45)", color: "white", textTransform: 'uppercase',
    margin: "10px", fontWeight: "bold", fontFamily: 'Open Sans', letterSpacing: '1.25px'
}

const syncBtnDisabledStyle = {
    background: "rgb(189,113,116)", color: "white", textTransform: 'uppercase',
    margin: "10px", fontWeight: "bold", fontFamily: 'Open Sans', letterSpacing: '1.25px'
}

class Synchronization extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            data: {
                currentStatus: null,
                lastStatus: null
            },
            syncInterval: null,
            startingSync: false
        }
        this.setState = this.setState.bind(this);
        this.lastSyncBlock = this.lastSyncBlock.bind(this);
        this.lastStatusesTables = this.lastStatusesTables.bind(this);
        this.createSyncInterval = this.createSyncInterval.bind(this);
        this.currentProgressBlock = this.currentProgressBlock.bind(this);
        this.getSyncStatuses = this.getSyncStatuses.bind(this);
        this.startFullSync = this.startFullSync.bind(this);
        this.startQuickSync = this.startQuickSync.bind(this);
        this.startRemovalSync = this.startRemovalSync.bind(this);
        this.startSync = this.startSync.bind(this);
        this.errorBlock = this.errorBlock.bind(this);
    }

    lastSyncBlock() {
        const {lastStatuses} = this.state.data;
        if (lastStatuses) {
            return (
                <div style={{background: '#ffffff', border: '2px solid #dfdfdf', marginTop: '20px'}}>
                    <Grid container spacing={0} style={{padding: 20}}>
                        <Grid item xs={12}>
                            <h2>Last synchronizations:</h2>
                        </Grid>
                        {this.lastStatusesTables()}
                    </Grid>
                </div>
            )
        } else {
            return (
                <div style={{background: '#ffffff', border: '2px solid #dfdfdf', marginTop: '20px'}}>
                    <Grid container spacing={0} style={{padding: 20}}>
                        <Grid item xs={12}>
                            <h2>Last synchronization:</h2>
                        </Grid>
                        <Grid item xs={12}>
                            Synchronization has never been done
                        </Grid>
                    </Grid>
                </div>
            )
        }
    }

    lastStatusesTables() {
        let tables = []
        const {lastStatuses} = this.state.data;
        for (let lastStatus of lastStatuses) {
            tables.push(<Grid item xs={12} key={lastStatus.type + '-' + lastStatus.endedTimestamp}>
                <Table padding="dense" size="small" style={{border: "1px solid lightgray"}}>
                    <TableBody>
                        <TableRow>
                            <TableCell>Type</TableCell>
                            <TableCell>{lastStatus.type}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Status</TableCell>
                            <TableCell>{lastStatus.status}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Towers added</TableCell>
                            <TableCell>{lastStatus.towersAdded}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Towers updated</TableCell>
                            <TableCell>{lastStatus.towersUpdated}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Towers removed</TableCell>
                            <TableCell>{lastStatus.towersRemoved}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Ended at</TableCell>
                            <TableCell>{new Date(Date.parse(lastStatus.endedTimestamp)).toLocaleString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Error message</TableCell>
                            <TableCell>{lastStatus.errorMessage}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <br/>
            </Grid>)
        }
        return tables;
    }

    createSyncInterval() {
        this.setState({
            syncInterval: setInterval(this.getSyncStatuses, 5000)
        })
    }

    errorBlock() {
        if (this.state.error) {
            return (
                <div
                    style={{background: '#ffffff', border: '2px solid #dfdfdf'}}>Error: {this.state.error.message}</div>
            )
        }
        return null
    }

    currentProgressBlock() {
        const {currentStatus} = this.state.data;
        if (!currentStatus) {
            return null
        }

        let value = currentStatus.towersProcessed / currentStatus.towersToProcess * 100;
        return (
            <Grid item xs={12} style={{padding: 20}}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="body2" style={{textAlign: "center"}}>
                            {currentStatus.towersToProcess
                                ? `${Math.round(value)}% (${currentStatus.towersProcessed}/${currentStatus.towersToProcess})`
                                : "Requesting towers list"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} style={{alignSelf: "center"}} style={{padding: 0}}>
                        <LinearProgress variant="determinate" value={currentStatus.towersProcessed ? value : 0}/>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    startRemovalSync() {
        this.startSync("REMOVAL")
    }

    startQuickSync() {
        this.startSync("QUICK")
    }

    startFullSync() {
        this.startSync("FULL")
    }

    startSync(type) {
        this.setState({
            startingSync: true
        })
        doPost("/web/sync/" + type, {}, ({response}) => {
            response = JSON.parse(response)
            if (!response.synchronizationStarted) {
                alert("Failed to start synchronization");
            }
            this.getSyncStatuses();
            this.setState({
                startingSync: false
            })
        });
    }

    getSyncStatuses() {
        getData("/web/sync/status", this.setState);
    }

    componentDidMount() {
        this.getSyncStatuses();
        this.createSyncInterval()
    }

    componentWillUnmount() {
        if (this.state.syncInterval) {
            clearInterval(this.state.syncInterval)
        }
    }

    render() {
        const {isLoaded, data, startingSync} = this.state;
        if (!isLoaded) {
            return <div className="text-center" style={{background: '#ffffff', border: '2px solid #dfdfdf'}}>
                <div className="spinner-border m-5"></div>
            </div>;
        } else {
            if (data.currentStatus) {
                return (
                    <div>
                        {this.errorBlock()}
                        <div style={{background: '#ffffff', border: '2px solid #dfdfdf'}}>

                            <Grid container spacing={0}>
                                <Grid item xs={12} style={{padding: 20}}>
                                    <h2>Synchronization progress:</h2>
                                </Grid>
                                {this.currentProgressBlock()}
                            </Grid>
                        </div>

                        {this.lastSyncBlock()}
                    </div>)
            } else {
                return (
                    <div>
                        {this.errorBlock()}
                        <div style={{position: "relative", height: "159px"}}>
                            <div style={{
                                left: "50%", top: "50%",
                                transform: "translate(-50%, -50%)", position: "absolute"
                            }}>
                                <Button disabled={startingSync} onClick={this.startFullSync}
                                        style={startingSync ? syncBtnDisabledStyle : syncBtnStyle}>
                                    START FULL SYNC
                                </Button>
                                <Button disabled={startingSync} onClick={this.startQuickSync}
                                        style={startingSync ? syncBtnDisabledStyle : syncBtnStyle}>
                                    START QUICK SYNC
                                </Button>
                                <Button disabled={startingSync} onClick={this.startRemovalSync}
                                        style={startingSync ? syncBtnDisabledStyle : syncBtnStyle}>
                                    START REMOVAL SYNC
                                </Button>
                            </div>
                        </div>
                        {this.lastSyncBlock()}
                    </div>
                )
            }
        }
    }
}

export default Synchronization